import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-quibbler-hp6-spectrespecs",
  name: `The Quibbler\n'Spectrespecs'`,
  nameFormatted: {
    primary: "The Quibbler",
    secondary: "'Spectrespecs'",
  },
  origin: `Harry Potter and the Half-Blood Prince`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
